var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnGps24 = function SvgLightIcnGps24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.975 4.5A7.475 7.475 0 0 0 4.5 11.976 7.475 7.475 0 1 0 11.975 4.5M3.5 11.976a8.475 8.475 0 1 1 16.95 0 8.476 8.476 0 0 1-16.95 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.57 11.976a1.595 1.595 0 1 1-3.19 0 1.595 1.595 0 0 1 3.19 0M12.475 4v3.722h-1V4zM12.475 16.23v3.72h-1v-3.72zM19.95 12.476H16.23v-1h3.722zM7.722 12.476H4v-1h3.722z",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnGps24;